<template>
    <div class="wakaf-list">
        <div v-for="(item, index) in wakafData" :key="index" class="wakaf-row" :class="{ 'border-top': index > 0 }">
            <div class="d-flex align-items-center gap-2 py-2 px-1">
                <span class="badge rounded-pill text-white flex-shrink-0" style="background: #4b2045; width: 24px; height: 24px; font-size: 0.7rem; display: flex; align-items: center; justify-content: center;">{{ index + 1 }}</span>

                <div class="row g-2 flex-grow-1 align-items-end">
                    <div class="col-lg">
                        <label class="field-label">Jenis Wakaf</label>
                        <select v-model="item.jenisWakaf" class="form-select form-select-sm"
                                @change="wakafDaerah(parseInt(($event.target as HTMLInputElement).value), index)">
                            <option disabled selected value="0">Sila pilih</option>
                            <option v-for="type in data.wakaf_type" :value="type.id">{{ type.Nama }}</option>
                        </select>
                    </div>
                    <div class="col-lg" v-if="!item.isHiddenDistrict && item.jenisWakaf !== 0">
                        <label class="field-label">Daerah</label>
                        <select v-model="item.daerahWakaf" class="form-select form-select-sm"
                                @change="daerahProjek(parseInt(($event.target as HTMLInputElement).value), item, index)">
                            <option disabled selected value="0">Pilih Daerah</option>
                            <option v-for="daerah in wakafData[index].district_list" :value="daerah.KodDaerah">{{ daerah.daerah }}</option>
                        </select>
                    </div>
                    <div class="col-lg" v-if="item.jenisWakaf === 2 && item.daerahWakaf !== 0">
                        <label class="field-label">Projek</label>
                        <select v-model="item.projekWakaf" class="form-select form-select-sm">
                            <option value="0" selected disabled>Pilih projek</option>
                            <option v-for="project in wakafData[index].project_list" :value="project.kod">{{ project.nama }}</option>
                        </select>
                    </div>
                    <div class="col-lg-auto">
                        <label class="field-label">Unit</label>
                        <div class="d-flex align-items-center gap-1">
                            <button class="unit-btn" type="button" @click="increment(false, item)">
                                <font-awesome-icon :icon="faMinus" />
                            </button>
                            <input v-model="item.unit" autocomplete="off" class="form-control form-control-sm text-center unit-input"
                                   max="200000000" min="1" type="number"
                                   @input="typeValueUpdate(($event.target as HTMLInputElement).value, item, index)" />
                            <button class="unit-btn" type="button" @click="increment(true, item)">
                                <font-awesome-icon :icon="faPlus" />
                            </button>
                        </div>
                    </div>
                    <div class="col-lg">
                        <label class="field-label">Bagi Pihak</label>
                        <select v-model="item.jenisPemilik" class="form-select form-select-sm"
                                @change="setWakafOwnName($event, item)">
                            <option disabled selected value="">Sila pilih</option>
                            <option v-for="jp in jenisPemilik" :value="jp">{{ jp }}</option>
                        </select>
                    </div>
                    <div class="col-lg">
                        <label class="field-label">Nama Pemilik</label>
                        <input v-if="item.jenisPemilik !== 'Sendiri'" v-model="item.namaPemilik"
                               class="form-control form-control-sm" placeholder="Nama pemilik" type="text"
                               @input="updateParentName(($event.target as HTMLInputElement).value, item, index)" />
                        <span v-else class="form-control form-control-sm bg-light text-muted text-truncate d-block">{{ item.namaPemilik || 'Nama pewakaf' }}</span>
                    </div>
                    <div class="col-lg-auto text-end">
                        <label class="field-label">Jumlah</label>
                        <div class="jumlah-display">{{ sumFormat(item.jumlah) }}</div>
                    </div>
                </div>

                <button v-if="wakafData.length > 1" type="button" class="btn-delete flex-shrink-0" title="Padam" @click="removeRow(index)">
                    <font-awesome-icon :icon="faTrash" />
                </button>
                <div v-else style="width: 28px;" class="flex-shrink-0"></div>
            </div>
        </div>
        <div v-if="wakafData.length === 0" class="text-center text-muted py-4">
            <p class="mb-0 small">Tiada wakaf ditambah lagi. Klik <strong>+ Tambah</strong> untuk mula.</p>
        </div>
    </div>
</template>
<script lang="ts" setup>
import {onMounted, ref} from "vue";
import Swal from "sweetalert2"
import {sumFormat} from "../../utils/utils";
import type {FormGeneral} from "../interface/FormGeneral";
import {faMinus, faPlus, faTrash} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {library} from "@fortawesome/fontawesome-svg-core";
library.add(faPlus, faMinus, faTrash);

const data = defineProps<{
    wakaf_type: [{
        id: number,
        Nama: string,
    }],
    wakaf_district: [{
        KodDaerah: number,
        WakafJenisID: number,
        daerah: string,
    }],
    wakaf_project: [{
        kod: number,
        nama: string,
        WakafJenisID: number,
        DaerahID: number,
    }],
    nama_pewakaf: string,
    userdata?: [IuserData],
    w_id?: number,
    d_id?: number,
    p_id?: number,
}>();
const emitToExternal = defineEmits<{
    (e: "calulateSum", sum: number): void,
    (e: "updateName", name: String, ownerType: String): void,
}>()
const wakafData = ref<FormGeneral[]>([]);

interface IuserData {
    ID: number,
    JenisWakaf: number,
    KodDaerah: number,
    Projek: number,
    Unit: number,
    jumlah: number,
    JenisPemilikan: string,
    NamaPemilik: string,
    Amaun: number,
    NoResitt: number,
    WakafResitID: number
}


const jenisPemilik = ref<string[]>(["Sendiri", "Mewakili Orang", "Mewakili Orang Meninggal"])
const wakafDaerah = (jenisWakaf: number, index: number, repeat?: number): void => {
    if (typeof repeat === "undefined") {
        wakafData.value[index].projekWakaf = 0;
        wakafData.value[index].daerahWakaf = 0;
    }
    wakafData.value[index].isHiddenDistrict = true;
    wakafData.value[index].district_list = [];
    switch (jenisWakaf){
        case 1: // Tabung wakaf tunai
            wakafData.value[index].projekWakaf = 26;
            wakafData.value[index].district_list = data.wakaf_district;
            wakafData.value[index].isHiddenDistrict = false;
            break;
        case 2: // Tabung wakaf projek
            let districtProjek: { KodDaerah: number, daerah: string }[] = getDaerahProjectIncluded();
            if (districtProjek.length > 0){
                wakafData.value[index].district_list = districtProjek;
                wakafData.value[index].isHiddenDistrict = false;
            }
            break;
        case 3: // Tabung wakaf masjid
            wakafData.value[index].daerahWakaf = 99;
            wakafData.value[index].projekWakaf = 3;
            break;
        case 4: // Tabung wakaf pendidikan
            wakafData.value[index].daerahWakaf = 99;
            wakafData.value[index].projekWakaf = 5;
            break;
        case 5: // Wakaf tunai
            wakafData.value[index].daerahWakaf = 99;
            wakafData.value[index].projekWakaf = 58;
            break;
    }
}

const getDaerahProjectIncluded = () : { KodDaerah: number, daerah: string }[] =>{
    let filteredDistricts: { KodDaerah: number, daerah: string }[] = [];
    const uniqueDistrictIDs = new Set();
    for (let p = 0; p < data.wakaf_project.length; p++){
        if(![3,5,26].includes(data.wakaf_project[p].kod) && data.wakaf_project[p].WakafJenisID ===2){
            uniqueDistrictIDs.add(data.wakaf_project[p].DaerahID);
        }
    }
    for (let q = 0; q < data.wakaf_district.length; q++){
        if(uniqueDistrictIDs.has(data.wakaf_district[q].KodDaerah)){
            filteredDistricts.push({
                KodDaerah : data.wakaf_district[q].KodDaerah,
                daerah : data.wakaf_district[q].daerah
            });
        }
    }
    return filteredDistricts;
}

const daerahProjek = (daerah: number, item: FormGeneral, index: number, repeat?: number): void => {
    if (typeof repeat === "undefined") {
        wakafData.value[index].projekWakaf = 0;
    }
    if (wakafData.value[index].jenisWakaf === 1){
        wakafData.value[index].projekWakaf = 26;
    }
    wakafData.value[index].project_list = [];
    wakafData.value[index].formError.daerahWakaf.valid = true;
    wakafData.value[index].formError.daerahWakaf.message = "";
    let filteredProjects: { kod: number, nama: string }[] = getProjectFiltered(item.jenisWakaf, daerah);
    if(filteredProjects.length > 0){
        wakafData.value[index].isHiddenProject = false;
        wakafData.value[index].project_list = filteredProjects;
    }
}
const getProjectFiltered = (jenisWakaf: number, daerah: number) : { kod: number, nama: string }[] =>{
    let filteredProjects: { kod: number, nama: string }[] = [];
    data.wakaf_project.forEach(function (item) {
        if (item["WakafJenisID"] === jenisWakaf && item["DaerahID"] === daerah) {
            filteredProjects.push({
                kod : item["kod"],
                nama : item["nama"]
            });
        }
    });
    return filteredProjects;
}
const increment = (isIncrease: Boolean, item: FormGeneral): void => {
    if (isIncrease && item.unit <= 200000000) {
        item.unit++;
    } else if (!isIncrease && item.unit > 1) {
        item.unit--;
    }
    item.jumlah = item.unit * 5;
    calulcateAllSum();
};

const typeValueUpdate = (typedValue: string, item: FormGeneral, index: number): void => {
    if (typedValue.match(/[^a-zA-Z0-9 ]/) || parseInt(typedValue) < 1 || parseInt(typedValue) >= 200000000) {
        wakafData.value[index].unit = 1;
    }
    if (isNaN(parseInt(typedValue))) {
        wakafData.value[index].unit = 1;
    }
    item.jumlah = item.unit * 5;
    calulcateAllSum();
}

const setWakafOwnName = (event: Event, item: FormGeneral): void => {
    const target = event.target as HTMLSelectElement;
    if (target.value === "Sendiri") {
        item.namaPemilik = data.nama_pewakaf;
        wakafData.value.forEach(function (itemm, indexx) {
            if (wakafData.value[indexx].jenisPemilik === "Sendiri") {
                wakafData.value[indexx].namaPemilik = data.nama_pewakaf
            }
        })
    } else {
        item.namaPemilik = ""
    }
}

const updateParentName = (name: string, item: FormGeneral, index: number): void => {
    if (item.jenisPemilik === "Sendiri") {
        wakafData.value.forEach(function (itemm, indexx) {
            if (wakafData.value[indexx].jenisPemilik === "Sendiri") {
                wakafData.value[indexx].namaPemilik = name
            }
        })
    }
    emitToExternal("updateName", wakafData.value[index].namaPemilik, wakafData.value[index].jenisPemilik);
}

const calulcateAllSum = (): void => {
    let sum: number = 0;
    wakafData.value.forEach(function (itemm) {
        sum += itemm.jumlah;
    })
    emitToExternal("calulateSum", sum);
}
const addRow = (): void => {
    if (wakafData.value.length < 10) {
        pushRow();
    } else if (wakafData.value.length >= 10) {
        Swal.fire({
            position: "center",
            icon: "info",
            title: "Hanya 10 transaksi dibenarkan bagi setiap pewakaf",
            timerProgressBar: true,
            timer: 1000
        })
    }
}

const pushRow = (): void => {
    wakafData.value.push({
        jenisWakaf: 0,
        daerahWakaf: 0,
        projekWakaf: 0,
        unit: 1,
        jumlah: 5,
        jenisPemilik: "",
        namaPemilik: "",
        district_list: [],
        project_list: [],
        isHiddenDistrict: true,
        isHiddenProject: true, // not in use
        isUpdate: false, // not in use
        editModalIndex: 0, // not in use
        formError:{
            jenisWakaf:{
                valid: true,
                message: "",
            },
            daerahWakaf:{
                valid: true,
                message: "",
            },
            projekWakaf:{
                valid: true,
                message: "",
            },
            unitWakaf:{
                valid: true,
                message: "",
            },
            pihakWakaf:{
                valid: true,
                message: "",
            },
            namaPemilikWakaf:{
                valid: true,
                message: "",
            },
        },
    });
    calulcateAllSum();
}
const removeRow = (index: number): void => {
    wakafData.value.splice(index, 1);
    calulcateAllSum();
}

defineExpose({
    wakafData,
    addRow
})

onMounted(() => {
    if (data.userdata === undefined) {
        pushRow();
    } else {
        wakafData.value = [];
        for (let i = 0; i < data.userdata.length; i++) {
            let unitt: number;
            let jumlahh: number;
            let projectCheck :{
                jenis: number,
                daerah: number,
                projek: number,
                isDisabledProject: boolean,
            } = {
                jenis: data.userdata[i].JenisWakaf,
                daerah: data.userdata[i].KodDaerah,
                projek: data.userdata[i].Projek,
                isDisabledProject: true,
            };
            if (data.userdata[i].Amaun < 5) {
                unitt = 1;
                jumlahh = 5;
            } else {
                unitt = Math.ceil(data.userdata[i].Amaun / 5);
                jumlahh = Math.ceil(data.userdata[i].Amaun / 5) * 5;
            }

            let noMatchedProjectFlag: boolean = false;
            for(let j: number = 0; j < data.wakaf_project.length; j++){
                if (data.wakaf_project[j].kod === data.userdata[i].Projek){
                    noMatchedProjectFlag = true;
                    break;
                }
            }

            if(!noMatchedProjectFlag){
                projectCheck.jenis = 1;
                projectCheck.daerah = 1;
                projectCheck.projek = 26;
                projectCheck.isDisabledProject = true;
            }

            const wd: FormGeneral = {
                jenisWakaf: projectCheck.jenis,
                daerahWakaf: projectCheck.daerah,
                projekWakaf: projectCheck.projek,
                unit: unitt,
                jumlah: jumlahh,
                jenisPemilik: data.userdata[i].JenisPemilikan,
                namaPemilik: data.userdata[i].NamaPemilik,
                district_list: [],
                project_list: [],
                isHiddenDistrict: projectCheck.isDisabledProject,
                isHiddenProject: false, // not in use
                isUpdate: false, // not in use
                editModalIndex: 0, // not in use
                formError:{
                    jenisWakaf:{
                        valid: true,
                        message: "",
                    },
                    daerahWakaf:{
                        valid: true,
                        message: "",
                    },
                    projekWakaf:{
                        valid: true,
                        message: "",
                    },
                    unitWakaf:{
                        valid: true,
                        message: "",
                    },
                    pihakWakaf:{
                        valid: true,
                        message: "",
                    },
                    namaPemilikWakaf:{
                        valid: true,
                        message: "",
                    },
                },
            };
            wakafData.value.push(wd);
            wakafDaerah(projectCheck.jenis, i, 1);
            daerahProjek(projectCheck.daerah, wd, i ,1)
        }
    }
    calulcateAllSum();
})
</script>
<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.wakaf-list {
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;
    overflow: hidden;
    background: #fff;
}

.wakaf-row {
    transition: background-color 0.15s ease;
}

.wakaf-row:hover {
    background-color: #f8f9fc;
}

.wakaf-row .border-top {
    border-color: #e5e7eb !important;
}

.field-label {
    display: block;
    font-size: 0.65rem;
    font-weight: 600;
    color: #1f2937;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    margin-bottom: 2px;
    white-space: nowrap;
}

.form-select, .form-control {
    border-radius: 0.375rem;
    border-color: #e5e7eb;
    font-size: 0.8rem;
}

.form-select:focus, .form-control:focus {
    border-color: #4b2045;
    box-shadow: 0 0 0 2px rgba(75, 32, 69, 0.1);
}

.unit-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    border: 1px solid #e5e7eb;
    border-radius: 0.375rem;
    background: #f9fafb;
    color: #6b7280;
    font-size: 0.6rem;
    cursor: pointer;
    transition: all 0.15s ease;
    flex-shrink: 0;
    padding: 0;
}

.unit-btn:hover {
    background: #4b2045;
    border-color: #4b2045;
    color: #fff;
}

.unit-input {
    width: 52px;
    font-size: 0.8rem;
    font-weight: 600;
}

.jumlah-display {
    font-weight: 700;
    font-size: 0.85rem;
    color: #d97706;
    line-height: 2;
    white-space: nowrap;
}

.btn-delete {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border: none;
    border-radius: 0.375rem;
    background: #fef2f2;
    color: #ef4444;
    font-size: 0.7rem;
    cursor: pointer;
    transition: all 0.15s ease;
    padding: 0;
}

.btn-delete:hover {
    background: #fee2e2;
    color: #dc2626;
}
</style>
